export default __webpack_public_path__ + "static/media/macy.411c4b54.svg";